<template>
  <div class="form-group">
    <slot name="label">
      <label v-if="showLabel" :for="d_for">
        {{ label }}
      </label>
    </slot>

    <slot name="input">
      <d-input v-model="d_value" :autocomplete="autocomplete" :disabled="disabled" :id="d_for" :placeholder="placeholder" :readonly="readonly" :state="error ? 'invalid' : null" :type="type" />
    </slot>

    <slot name="error">
      <d-form-invalid-feedback v-if="error" class="invalid-feedback">
        {{ error }}
      </d-form-invalid-feedback>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'form-group',
  props: {
    autocomplete: {
      type: String,
      default: 'on'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: undefined,
    },
    for: String,
    label: String,
    placeholder: String,
    readonly: Boolean,
    showLabel: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => {
        return [
          'text', 'email', 'password', 'tel', 'number'
        ].indexOf(value) !== -1;
      },
    },
    value: String | Number,
  },
  data () {
    return {
      d_for: this.for === undefined ? this.label : this.for,
      d_value: this.value,
    };
  },
  watch: {
    d_value () {
      this.$emit('input', this.d_value);
    },
    value (value) {
      this.d_value = value;
    },
  },
}
</script>
